import React from 'react';
import Button from 'react-bootstrap/Button';

const ActionBarCpanelUsers = ({ showFormAdd, showFormImport, showFormExport, disabled = false }) => (
  <div className="cpanel-action-bar d-flex flex-wrap gap-2">
    <Button variant="primary" size="sm" onClick={showFormAdd} disabled={disabled}>
      Tambah Pengguna
    </Button>
    <Button variant="light-primary" size="sm" onClick={showFormImport} disabled={disabled}>
      Impor
    </Button>
    <Button variant="light-success" size="sm" onClick={showFormExport} disabled={disabled}>
      Ekspor
    </Button>
  </div>
);

export default ActionBarCpanelUsers;
